import {
    Pipe,
    PipeTransform
} from '@angular/core';

@Pipe({
    name: 'n2br',
    standalone: false
})
export class LineBreakPipe implements PipeTransform {

    public constructor() {
    }

    transform(value: string): string {
      return value.replace(/\n/g, '<br>');     
    }
}
